module.exports = __webpack_public_path__ + "img/smakraft.65472697.jpg";